import React from 'react';
import { makeColorSetClass } from '@spotify-internal/encore-web-v6';
import { FooterWrapper, SubFooter, FooterContent } from './Footer.styles';
import { Policies } from './Features/Policies';
import { Copyright } from './Features/Copyright';
import { Social } from './Features/Social';
import { Language } from './Features/Language';
import { HelpfulLinks } from './Features/HelpfulLinks';
import { CreatorTools } from './Features/CreatorTools';
import { GetTheApp } from './Features/GetTheApp';
import { Logo } from './Features/Logo';

export const Footer: React.FC = () => {
  return (
    <FooterWrapper className={makeColorSetClass('invertedDark')}>
      <FooterContent>
        <div className="logo">
          <Logo />
        </div>
        <div className="columns">
          <div className="column">
            <HelpfulLinks />
          </div>
          <div className="column">
            <CreatorTools />
          </div>
          <div className="column">
            <GetTheApp />
          </div>
        </div>
        <div className="social">
          <Social />
        </div>
      </FooterContent>
      <SubFooter>
        <div className="copyright-policies">
          <Copyright />
          <Policies />
        </div>
        <div className="language">
          <Language />
        </div>
      </SubFooter>
    </FooterWrapper>
  );
};
